/**
 * Approving exactly what was shown (ADR-022 + ADR-034). An approval records
 * the app's roles policy, so it names the one the approver's disclosure
 * showed; a publish since refuses it (`ACCESS_POLICY_CHANGED`, 409) instead
 * of approving roles nobody saw.
 */
import type { ArcheApprovalDisclosureDto } from '@/lib/api';

/**
 * What approving `disclosure` sends: its policy id, or null when it showed no
 * roles. Nothing from a server whose disclosures predate roles (no `access`
 * field), which knows no such field.
 */
export function disclosedAccessPolicy(disclosure: Pick<ArcheApprovalDisclosureDto, 'access'>): {
  expectedAccessPolicyId?: string | null;
} {
  return disclosure.access === undefined
    ? {}
    : { expectedAccessPolicyId: disclosure.access?.policyId ?? null };
}
